import { createI18n, LocaleMessages } from 'vue-i18n';
import * as Sentry from '@sentry/vue';
import en from './locales/en.json';
import es419 from './locales/es-419.json';
import fr from './locales/fr.json';

function loadLocaleMessages(): Record<string, LocaleMessages<object>> {
  return {
    en,
    fr,
    'es-419': es419,
  };
}

export const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: loadLocaleMessages(),
  missing: (_locale, key) => {
    Sentry.captureMessage(`Missing translation key: ${key}`);
  },
});
